import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styles: [`
    .toast-container {
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .toast {
      background: #2c2c2c;
      border: 1px solid rgba(255,255,255,0.1);
      color: #f0f0f0;
      padding: 12px 16px;
      font-size: 13px;
      min-width: 280px;
      max-width: 380px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.4);
      animation: slideIn 0.2s ease-out;
    }
    .toast-title { font-weight: 600; margin-bottom: 2px; }
    .toast-desc { color: rgba(255,255,255,0.6); font-size: 12px; }
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `]
})
export class ToastContainerComponent {
  toastService = inject(ToastService);
}
